/* GRWM v3 shared patches */

/* ---------- GRWMx: shared helpers for home sections (size sheet, add to bag, toast, drag, recently viewed) ---------- */
(function(){
  if(window.GRWMx)return;
  var root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
  var H={'Content-Type':'application/json','Accept':'application/json'};
  var cache={};
  function esc(t){return String(t==null?'':t).replace(/[&<>"']/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];});}
  function money(c){return '\u20b9'+Math.round((c||0)/100).toLocaleString('en-IN');}
  function img(u,w){if(!u)return '';u=String(u);if(u.indexOf('//')===0)u='https:'+u;return u+(u.indexOf('?')>-1?'&':'?')+'width='+(w||400);}
  function lockOff(){if(!document.querySelector('[data-lock-keep].is-on'))document.documentElement.classList.remove('gx-lock');}

  /* toast */
  var tEl,tT;
  function toast(msg,ok){
    if(!tEl){tEl=document.createElement('div');tEl.className='gx-toast';tEl.setAttribute('role','status');tEl.setAttribute('aria-live','polite');document.body.appendChild(tEl);}
    tEl.innerHTML=msg;tEl.classList.toggle('is-err',ok===false);tEl.classList.add('is-on');
    clearTimeout(tT);tT=setTimeout(function(){tEl.classList.remove('is-on');},2800);
  }

  function get(h){
    if(!cache[h])cache[h]=fetch(root+'products/'+encodeURIComponent(h)+'.js',{headers:{'Accept':'application/json'}}).then(function(r){if(!r.ok)throw new Error('Not found');return r.json();});
    return cache[h];
  }

  function add(items,msg){
    return fetch(root+'cart/add.js',{method:'POST',headers:H,body:JSON.stringify({items:items})})
      .then(function(r){return r.json().then(function(j){if(!r.ok)throw j;return j;});})
      .then(function(j){
        if(window.grwmRefreshCart){try{window.grwmRefreshCart();}catch(e){}}
        document.dispatchEvent(new CustomEvent('grwm:cart-updated',{detail:j}));
        toast(msg||('Added to bag \u2713 <a href="'+root+'cart">View bag</a>'));
        return j;
      })
      .catch(function(e){toast(esc((e&&(e.description||e.message))||'Could not add. Try again.'),false);throw e;});
  }

  /* size / variant sheet */
  var sh,body,state,ct;
  function build(){
    sh=document.createElement('div');sh.className='gx-sheet';sh.hidden=true;
    sh.innerHTML='<div class="gx-sheet__bg" data-x></div><div class="gx-sheet__panel" role="dialog" aria-modal="true" aria-label="Choose your size"><button type="button" class="gx-sheet__x" data-x aria-label="Close">&times;</button><div class="gx-sheet__body"></div></div>';
    document.body.appendChild(sh);body=sh.querySelector('.gx-sheet__body');
    sh.addEventListener('click',function(e){
      if(e.target.closest('[data-x]')){close(true);return;}
      var c=e.target.closest('[data-opt]');
      if(c&&!c.disabled){state.sel[+c.dataset.i]=c.dataset.v;render();var f=body.querySelector('[data-go]');if(f)f.focus({preventScroll:true});return;}
      if(e.target.closest('[data-go]'))go();
    });
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&sh&&!sh.hidden)close(true);});
  }
  function close(cancel){
    if(!sh||sh.hidden)return;
    sh.classList.remove('is-on');clearTimeout(ct);ct=setTimeout(function(){sh.hidden=true;},260);lockOff();
    if(cancel&&state&&state.o.onCancel)state.o.onCancel();
  }
  function match(){
    var p=state.p;
    for(var i=0;i<p.variants.length;i++){var v=p.variants[i],ok=true;for(var k=0;k<state.sel.length;k++){if(v.options[k]!==state.sel[k]){ok=false;break;}}if(ok)return v;}
    return null;
  }
  function avail(i,val){
    return state.p.variants.some(function(v){if(!v.available||v.options[i]!==val)return false;for(var k=0;k<i;k++){if(v.options[k]!==state.sel[k])return false;}return true;});
  }
  function render(){
    var p=state.p,o=state.o,v=match();
    var pr=v?v.price:p.price,cp=v?v.compare_at_price:p.compare_at_price;
    var im=(v&&v.featured_image&&v.featured_image.src)||p.featured_image;
    var h='<div class="gx-sheet__top"><img src="'+img(im,300)+'" alt="" width="96" height="120"><div>'+
      (o.step?'<div class="gx-sheet__step">'+esc(o.step)+'</div>':'')+
      '<h3>'+esc(p.title)+'</h3><div class="gx-sheet__price"><b>'+money(pr)+'</b>'+(cp>pr?'<s>'+money(cp)+'</s>':'')+'</div>'+
      '<a class="gx-sheet__more" href="'+p.url+'">View details &rarr;</a></div></div>';
    var single=p.variants.length===1&&(p.variants[0].title==='Default Title');
    if(!single){
      (p.options||[]).forEach(function(op,i){
        var name=op.name||op,vals=op.values||[];
        h+='<div class="gx-opt"><div class="gx-opt__l">'+esc(name)+'<span>'+esc(state.sel[i]||'')+'</span></div><div class="gx-opt__row">';
        vals.forEach(function(val){var a=avail(i,val);h+='<button type="button" class="gx-chip'+(state.sel[i]===val?' is-on':'')+'" data-opt data-i="'+i+'" data-v="'+esc(val)+'"'+(a?'':' disabled')+'>'+esc(val)+'</button>';});
        h+='</div></div>';
      });
    }
    var can=v&&v.available;
    h+='<button type="button" class="g-btn g-btn--primary gx-sheet__go" data-go'+(can?'':' disabled')+'>'+(v?(v.available?esc(o.cta||'Add to bag'):'Sold out'):'Unavailable')+'</button>';
    body.innerHTML=h;
  }
  function go(){
    var v=match();if(!v||!v.available)return;
    var o=state.o,p=state.p,btn=body.querySelector('[data-go]');
    if(o.onPick){var im=body.querySelector('.gx-sheet__top img');if(im)window.__gxSheetSnap={rect:im.getBoundingClientRect(),src:im.currentSrc||im.src,t:Date.now()};close(false);o.onPick(v,p);return;}
    btn.disabled=true;btn.textContent='Adding\u2026';
    add([{id:v.id,quantity:1}]).then(function(){close(false);}).catch(function(){btn.disabled=false;btn.textContent=o.cta||'Add to bag';});
  }
  function pick(h,o){
    o=o||{};if(!sh)build();
    return get(h).then(function(p){
      var first=p.variants.filter(function(v){return v.available;})[0]||p.variants[0];
      if(p.variants.length===1){
        if(!first.available){toast('Sold out',false);if(o.onCancel)o.onCancel();return;}
        if(o.onPick){o.onPick(first,p);return;}
        return add([{id:first.id,quantity:1}]);
      }
      state={p:p,o:o,sel:first.options.slice()};render();
      clearTimeout(ct);sh.hidden=false;document.documentElement.classList.add('gx-lock');
      requestAnimationFrame(function(){sh.classList.add('is-on');});
      var f=body.querySelector('.gx-chip.is-on')||body.querySelector('[data-go]');if(f)f.focus({preventScroll:true});
    }).catch(function(){toast('Could not load this product',false);});
  }
  /* pick several products one after another, then add them all together */
  function pickMany(hs,doneMsg){
    var out=[],i=0;
    (function next(){
      if(i>=hs.length){if(out.length)add(out.map(function(v){return{id:v.id,quantity:1};}),doneMsg||('Full look added \u2713 <a href="'+root+'cart">View bag</a>'));return;}
      var h=hs[i];i++;
      pick(h,{cta:i<hs.length?'Next item \u2192':'Add '+(out.length+1)+' items to bag',step:'Item '+i+' of '+hs.length,onPick:function(v){out.push(v);next();}});
    })();
  }

  /* mouse drag-to-scroll for horizontal rows */
  function drag(el){
    var down=false,sx=0,sl=0,moved=false;
    el.addEventListener('mousedown',function(e){if(e.button!==0)return;down=true;moved=false;sx=e.pageX;sl=el.scrollLeft;});
    window.addEventListener('mousemove',function(e){if(!down)return;var d=e.pageX-sx;if(!moved&&Math.abs(d)>6){moved=true;el.classList.add('is-drag');}if(moved)el.scrollLeft=sl-d;});
    window.addEventListener('mouseup',function(){if(!down)return;down=false;el.classList.remove('is-drag');});
    el.addEventListener('click',function(e){if(moved){e.preventDefault();e.stopPropagation();moved=false;}},true);
    el.addEventListener('dragstart',function(e){e.preventDefault();});
  }
  function initDrag(scope){(scope||document).querySelectorAll('[data-drag]:not([data-drag-on])').forEach(function(el){el.setAttribute('data-drag-on','');drag(el);});}

  /* global click hooks */
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-gx-pick]');
    if(b){e.preventDefault();pick(b.getAttribute('data-gx-pick'));return;}
    var l=e.target.closest('[data-gx-look]');
    if(l){e.preventDefault();var hs=l.getAttribute('data-gx-look').split(',').filter(Boolean);if(hs.length)pickMany(hs);}
  });

  /* record recently viewed products */
  try{
    var m=location.pathname.match(/\/products\/([^\/?#]+)/);
    if(m){var hh=decodeURIComponent(m[1]),a=JSON.parse(localStorage.getItem('grwm_rv')||'[]');a=a.filter(function(x){return x!==hh;});a.unshift(hh);localStorage.setItem('grwm_rv',JSON.stringify(a.slice(0,12)));}
  }catch(e){}

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){initDrag();});else initDrag();
  document.addEventListener('shopify:section:load',function(e){initDrag(e.target);});

  window.GRWMx={add:add,pick:pick,pickMany:pickMany,get:get,toast:toast,money:money,esc:esc,img:img,initDrag:initDrag,root:root};
})();

/* ---------- collection toolbar: hide on scroll down, show on scroll up (survives filter re-renders) ---------- */
(function(){
  var lastY=window.scrollY,tk=false;
  function getBar(){
    var b=document.querySelector('.g-col__bar');if(!b)return null;
    var m=b.previousElementSibling;
    if(!m||!m.hasAttribute('data-gx-mark')){m=document.createElement('div');m.setAttribute('data-gx-mark','');m.setAttribute('aria-hidden','true');m.style.cssText='height:0;margin:0;padding:0';b.parentNode.insertBefore(m,b);}
    return b;
  }
  function upd(){
    tk=false;var y=window.scrollY,d=y-lastY,b=getBar();
    if(!b){lastY=y;return;}
    var top=parseFloat(getComputedStyle(b).top)||0,stuck=b.previousElementSibling.getBoundingClientRect().top<top-1;
    var col=document.getElementById('GrwmCollection');
    if(!stuck||(col&&col.classList.contains('facets-open')))b.classList.remove('is-hid');
    else if(d>6)b.classList.add('is-hid');
    else if(d<-6)b.classList.remove('is-hid');
    if(Math.abs(d)>6)lastY=y;
  }
  window.addEventListener('scroll',function(){if(!tk){tk=true;requestAnimationFrame(upd);}},{passive:true});
  document.addEventListener('focusin',function(e){var b=e.target.closest&&e.target.closest('.g-col__bar');if(b)b.classList.remove('is-hid');});
})();

/* ---------- sticky bag + wrap-and-fly animation for every add to cart ---------- */
(function(){
  if(window.__gxBag)return;window.__gxBag=1;
  var root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
  var path=location.pathname,hideBag=/\/products\//.test(path)||/\/cart\/?$/.test(path);
  var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  var bag=null,cnt=null,lastTap=null,lastTapT=0;
  function mk(){
    if(hideBag||bag||!document.body)return;
    bag=document.createElement('a');bag.id='GxBag';bag.className='gx-bag';bag.href=root+'cart';bag.setAttribute('aria-label','Bag');
    bag.innerHTML='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5.5 8h13l-1 12.5h-11L5.5 8z"/><path d="M9 8V6.5a3 3 0 0 1 6 0V8"/></svg><b class="gx-bag__n">0</b>';
    document.body.appendChild(bag);cnt=bag.querySelector('.gx-bag__n');
  }
  function setCount(n){if(!cnt)return;cnt.textContent=n>99?'99+':n;bag.classList.toggle('has-items',n>0);bag.setAttribute('aria-label','Bag, '+n+' item'+(n===1?'':'s'));}
  function refresh(){return fetch(root+'cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(c){setCount(c.item_count||0);}).catch(function(){});}
  function bump(){if(!bag)return;bag.classList.remove('is-bump');void bag.offsetWidth;bag.classList.add('is-bump');}
  document.addEventListener('pointerdown',function(e){lastTap=e.target;lastTapT=Date.now();},{capture:true,passive:true});
  function snap(){
    var s=window.__gxSheetSnap;
    if(s&&Date.now()-s.t<2500){window.__gxSheetSnap=null;return s;}
    var sh=document.querySelector('.gx-sheet.is-on .gx-sheet__top img');
    if(sh)return{rect:sh.getBoundingClientRect(),src:sh.currentSrc||sh.src};
    if(!lastTap||!lastTap.closest||Date.now()-lastTapT>8000)return null;
    var box=lastTap.closest('.g-card,.g-look__row,.g-look__stage,.g-reel,.g-cb__item,.g-cb__bar,.g-trend__item,.g-cr__card,[data-product-card],article,li');
    var img=box&&box.querySelector('img');
    if(!img)return{rect:lastTap.getBoundingClientRect(),src:''};
    return{rect:img.getBoundingClientRect(),src:img.currentSrc||img.src};
  }
  function fly(s){
    if(!bag||!s||!s.rect||reduce||!document.body.animate){bump();refresh();return;}
    var r=s.rect,b=bag.getBoundingClientRect();
    if(r.width<2||r.bottom<0||r.top>innerHeight){bump();refresh();return;}
    var S=64,sx=r.left+r.width/2,sy=r.top+r.height/2,tx=b.left+b.width/2,ty=b.top+b.height/2;
    var s0=Math.max(.6,Math.min(3.4,Math.min(r.width,r.height)/S));
    var ox=document.createElement('div');ox.className='gx-fly';ox.style.left=(sx-S/2)+'px';ox.style.top=(sy-S/2)+'px';
    var oy=document.createElement('div');oy.className='gx-fly__y';
    var p=document.createElement('div');p.className='gx-fly__p';
    if(s.src)p.style.backgroundImage='url("'+String(s.src).replace(/["\\]/g,'')+'")';
    p.innerHTML='<i class="gx-fly__bow"></i>';
    oy.appendChild(p);ox.appendChild(oy);document.body.appendChild(ox);
    var dx=tx-sx,dy=ty-sy,peak=Math.min(0,dy)-Math.max(90,Math.abs(dx)*.3);
    var wrap=p.animate([
      {transform:'scale('+s0+') rotate(0deg)'},
      {transform:'scale('+(s0*.45+.55)+') rotate(-4deg)',offset:.55},
      {transform:'scale(1) rotate(-8deg)'}
    ],{duration:340,easing:'cubic-bezier(.2,.8,.2,1)',fill:'forwards'});
    setTimeout(function(){p.classList.add('is-wrap');},120);
    wrap.onfinish=function(){
      var dur=Math.round(Math.min(820,Math.max(520,Math.sqrt(dx*dx+dy*dy)*.8)));
      ox.animate([{transform:'translate3d(0,0,0)'},{transform:'translate3d('+dx+'px,0,0)'}],{duration:dur,easing:'cubic-bezier(.3,.1,.45,1)',fill:'forwards'});
      oy.animate([
        {transform:'translate3d(0,0,0)',easing:'cubic-bezier(.2,.7,.4,1)'},
        {transform:'translate3d(0,'+peak+'px,0)',offset:.38,easing:'cubic-bezier(.6,0,.9,.55)'},
        {transform:'translate3d(0,'+dy+'px,0)'}
      ],{duration:dur,fill:'forwards'});
      var fin=p.animate([
        {transform:'scale(1) rotate(-8deg)'},
        {transform:'scale(.95) rotate(80deg)',offset:.5},
        {transform:'scale(.26) rotate(200deg)'}
      ],{duration:dur,easing:'ease-in',fill:'forwards'});
      fin.onfinish=function(){ox.remove();bump();refresh();};
    };
  }
  var of=window.fetch;
  if(of&&!of.__gx){
    var nf=function(input){
      var url=(input&&input.url)||String(input||'');
      var isAdd=/\/cart\/add/.test(url),isMut=/\/cart\/(add|change|update|clear)/.test(url);
      var s=isAdd?snap():null;
      var pr=of.apply(this,arguments);
      if(isMut)pr.then(function(r){if(!r.ok)return;if(isAdd)fly(s);else refresh();}).catch(function(){});
      return pr;
    };
    nf.__gx=1;window.fetch=nf;
  }
  function init(){mk();refresh();}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  window.addEventListener('pageshow',function(e){if(e.persisted)refresh();});
  window.GRWMbag={refresh:refresh,fly:fly};
})();
